import { REVIEW_STATS } from "@/data/reviews";

/**
 * Product-markup voor "Groepenkast vervangen" met de echte reviewcijfers
 * uit src/data/reviews.ts. Op verzoek van de eigenaar alleen op de
 * groepenkastpagina's: vrijwel alle reviews gaan over groepenkastvervanging.
 * Geen prijs (er worden online geen prijzen getoond).
 */
export function groepenkastProductJsonLd(opts: { url: string; name: string; description: string }) {
  return {
    type: "application/ld+json",
    children: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Product",
      name: opts.name,
      description: opts.description,
      url: opts.url,
      category: "Groepenkast vervangen",
      brand: { "@type": "Brand", name: "Elvion Group Nederland" },
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: String(REVIEW_STATS.totaal.score),
        bestRating: String(REVIEW_STATS.totaal.schaal),
        worstRating: "1",
        ratingCount: String(REVIEW_STATS.totaal.aantal),
        reviewCount: String(REVIEW_STATS.totaal.aantal),
      },
    }),
  };
}
